import React from 'react';
import LeadershipLessons from '../../../src/Images/LeassonsLearnedAboutLeadershipMotArticle.png';
import ExploratoryTools from '../../../src/Images/ExploratoryToolsForBetterTesting.jpg';
import MisconceptionsExploratory from '../../../src/Images/CommonMisconceptionsAboutExploratoryTesting.jpg';
import ChallengesInTestingLegacySystems from '../../../src/Images/ChallengesInTestingLegacySystems.png';
import TestingAMA from '../../../src/Images/MotAmaTestingToolsWithMirzaSisic.png';
import ModernTestingPrinciples from '../../../src/Images/ModernTestingPrinciples.jpg';
import OrganizingYourVeryOwnTestingMeetup from '../../../src/Images/OrganizingYourVeryOwnTestingMeetup.jpg';
import ModernTestingBestPractices from '../../../src/Images/ModernTestingBestPractices.jpg';
import TheRoleOfQaInSoftwareDevelopment from '../../../src/Images/TheRoleOfQaInSoftwareDevelopment.jpg';
import MotSarajevo1 from '../../../src/Images/MotSarajevo1.jpg';
import iSQI from '../../../src/Images/iSQI.jpg';
import GeekleModerationCert from '../../../src/Images/GeekleModerationCert.png';
import TestBashCareers from '../../../src/Images/TestBashCareers.jpg';
import TestBashWorldSarajevoWatchParty from '../../../src/Images/TestBashWorldSarajevoWatchParty.jpeg';
import AutomationForJuniorTesters from '../../../src/Images/AutomationForJuniorTesters.png';
import MakeE2eTestingEasierWithTheRightTools from '../../../src/Images/MakeE2eTestingEasierWithTheRightTools.png';
import TwitterSpaceLetsExploreBDD from '../../../src/Images/TwitterSpaceLetsExploreBDD.png';
import Testival2022 from '../../../src/Images/Testival2022.png';
import SarajevoQaCrewMeetup from '../../../src/Images/SarajevoQaCrewMeetup.jpg';
import ExploreAgileSpikesShiftLeftBdd from '../../../src/Images/ExploreAgileSpikesShiftLeftBdd.png';
import MirzaAgileBosniaDays from '../../../src/Images/MirzaAgileBosniaDays.jpg';
import ProductOwnerQA from '../../../src/Images/ProductOwnerQA.jpg';
import TestshpereRoulettePodcast from '../../../src/Images/TestshpereRoulettePodcast.jpg';
import TestBashSpringIanMirzaPokekon from '../../../src/Images/TestBashSpringIanMirzaPokekon.png';
import MobileTestingISQI from '../../../src/Images/MobileTestingISQI.jpg';
import BugRaptorsInterview from '../../../src/Images/BugRaptorsInterview.jpeg';
import TestExecutionTime from '../../../src/Images/TestExecutionTime.jpeg';
import MotSarajevo2023 from '../../../src/Images/MotSarajevo2023.jpg';
import FreelancingForSoftwareTesters from '../../../src/Images/FreelancingForSoftwareTesters.jpg';
import NetWorkBih2023 from '../../../src/Images/NetWorkBih2023.png';
import QualityCoachingRoadLessTraveled from '../../../src/Images/QualityCoachingRoadLessTraveled.jpg';
import FeatureSpotlightsJQL from '../../../src/Images/FeatureSpotlightsJQL.jpg';
import MotSarajevo2024 from '../../../src/Images/MotSarajevo2024.jpeg';
import SystemDuoManualQACourse from '../../../src/Images/SystemDuoManualQACourse.jpg';
import BeatingTheOddsMot from '../../../src/Images/BeatingTheOddsMot.jpg';
import TestCasesMoT from '../../../src/Images/TestCasesMoT.jpg';
import ReleaseOnFridays from '../../../src/Images/ReleaseOnFridays.jpg';
import BrowserStack1stMeetup from '../../../src/Images/BrowserStack1stMeetup.jpg';
import NetworkBiH2024WhyIAlmostGaveUpOnQA from '../../../src/Images/NetworkBiH2024WhyIAlmostGaveUpOnQA.jpg';
import AllAboutApplicationCookies from '../../../src/Images/AllAboutApplicationCookies.jpg';
import BrowserStackFeb2025 from '../../../src/Images/sarajevo_browserstack_mirza_february.png';
import BrowserStackMay2025 from '../../../src/Images/BrowserStack2ndtMeetup.jpg';
import LowCodeTestTutomationTools from '../../../src/Images/LowCodeTestTutomationTools.jpg';
import BugBash2025 from '../../../src/Images/BugBash2025.jpg';
import MotFairPay from '../../../src/Images/MotFairPay.jpg';
import MotSarajevo2025Meetup from '../../../src/Images/MotSarajevo2025Meetup.jpg';
import Network2025 from '../../../src/Images/Network2025.png';
import BrowserStackDecember2025 from '../../../src/Images/BrowserStackDecember2025.png';
import BrowserStackmarch2026 from '../../../src/Images/BrowserStackmarch2026.png';
import SoftwareTestingInRegulatedIndustriesCourse from '../../../src/Images/SoftwareTestingInRegulatedIndustriesCourse.jpg';
import breakpoint2026 from '../../../src/Images/breakpoint2026.jpg';
import BrowserStackMay2026 from '../../../src/Images/BrowserStackMay2026.png';
import GdgSarajevoMay2026 from '../../../src/Images/GdgSarajevoMay2026.jpg';
import MotSarajevoJune2026 from '../../../src/Images/MotSarajevoJune2026.jpg';






const Projects = () => (
  <div className="container">
    <div className="container" id="workwrap">
      <h3 className="text-center heading">
        <strong>Activities</strong>
      </h3>
      <h4 className="minor-heading">
        <strong>What I've been up to lately</strong>
      </h4>

      <div className="row center">
        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={LeadershipLessons}
              alt="Lessons Learned About Leadership, From Perspective Of An Aspiring Leader - For testers trying to get into Team Lead or similar roles, article by Mirza Sisic"
            />
            <div className="caption">
              <h3>
                Lessons Learned About Leadership, From Perspective Of An
                Aspiring Leader
              </h3>
              <p className="DarkGreyHeading">MoT - The Testing Planet</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://www.ministryoftesting.com/articles/f0720cc9?s_id=14301141"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Read the article
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={ExploratoryTools}
              alt="Software Tools For Easy, Effective Exploratory Testing, article by Mirza Sisic"
            />
            <div className="caption">
              <h3>
                Software Tools <br /> For Easy, Effective Exploratory Testing
              </h3>
              <br />
              <p className="DarkGreyHeading">MoT - The Testing Planet</p>
              <br />

              <p>
                <a
                  href="https://www.ministryoftesting.com/articles/113fa955?s_id=14301142"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Read the article
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={TestingAMA}
              alt="Testing Ask Me Anything - Testing Tools with Mirza Sisic"
            />
            <div className="caption">
              <h3>Testing AMA - Ask Me Anything <br /> Testing Tools with Mirza Sisic</h3>
              <p className="DarkGreyHeading">MoT - Testing AMA</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://www.ministryoftesting.com/ask-me-anythings/607a3cd6?s_id=14301151"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Watch the recording
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={MisconceptionsExploratory}
              alt="Common Misconceptions About Exploratory Testing - article"
            />
            <div className="caption">
              <h3>Common Misconceptions About Exploratory Testing</h3>
              <p className="DarkGreyHeading">MoT - The Testing Planet</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://www.ministryoftesting.com/articles/7bd1afdc?s_id=14301143"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Read the article
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row   text-align: center">

        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={ChallengesInTestingLegacySystems}
              alt="Challenges in Testing Legacy Systems - blog article for TestProject, by Mirza Sisic"
            />
            <div className="caption">
              <h3>Testing Legacy Systems</h3>
              <p className="DarkGreyHeading">TestProject - Blog Article</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://blog.testproject.io/08/16/challenges-in-testing-legacy-systems/"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Read the article
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={ModernTestingPrinciples}
              alt="Modern Testing Principles - blog article for TestProject, by Mirza Sisic"
            />
            <div className="caption">
              <h3>Modern Testing Principles</h3>
              <p className="DarkGreyHeading">TestProject - Blog Article</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://blog.testproject.io/2022/04/21/modern-testing-principles/"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Read the article
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={OrganizingYourVeryOwnTestingMeetup}
              alt="Organizing Your Very Own Testing Meetup - article"
            />
            <div className="caption">
              <h3>Organizing Your Very Own Testing Meetup</h3>
              <p className="DarkGreyHeading">MoT - The Testing Planet</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://www.ministryoftesting.com/articles/042e4019?s_id=14301152"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Read the article
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={MotSarajevo1}
              alt="MoT Sarajevo's First Meetup with Maaret Pyhäjärvi, Conor Fitzgerald and Larry Goddard - meetup"
            />
            <div className="caption">
              <h3>MoT Sarajevo's First Meetup</h3>
              <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://www.ministryoftesting.com/talks/93d74186?s_id=14301185"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  Watch the Recording
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="row   text-align: center">
      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={iSQI} alt="MoT Sarajevo's First Meetup with Maaret Pyhäjärvi, Conor Fitzgerald and Larry Goddard - meetup" />
          <div className="caption">
            <h3>ISTQB Certification: where to start?</h3>
            <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p><a href="https://dms.licdn.com/playlist/C4E05AQEiM-1NDE-aoA/mp4-720p-30fp-crf28/0/1642435046149?e=1652281200&v=beta&t=5VFQTbOqxIFVg-gl4MpXMpQuQCCiNx4LSOgztTpvSmE" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" disabled type="button" role="button">Recording Unavailable</a></p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={TheRoleOfQaInSoftwareDevelopment}
            alt="The role of QA in software development with Velibor Mandžo - meetup"
          />
          <div className="caption">
            <h3>QA role in Software Development</h3>
            <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/talks/e384569f?s_id=14301183"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Watch the Recording
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={ModernTestingBestPractices}
            alt="Modern Testing Best Practices with Venkat Ramakrishnan - meetup"
          />
          <div className="caption">
            <h3>Modern Testing Best Practices</h3>
            <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/ministry-of-testing-sarajevo/events/284819119/"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View the event
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={GeekleModerationCert}
            alt="MoT Sarajevo's First Meetup with Maaret Pyhäjärvi, Conor Fitzgerald and Larry Goddard - meetup"
          />
          <div className="caption">
            <h3>QA Global Summit 2022</h3>
            <p className="DarkGreyHeading">Geekle - Conference</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://youtu.be/RVDXWiqFX0M?t=594"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Watch the Recording
              </a>
            </p>
          </div>
        </div>
      </div>

    </div>

    <div className="row   text-align: center">
      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={TestBashCareers}
            alt="How to Market Yourself Better as a Software Tester - online conference presentation with Q and A"
          />
          <div className="caption">
            <h3>TestBash Careers</h3>
            <p className="DarkGreyHeading">MoT - Conference</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/events/testbash-careers-2022"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Watch the Recording
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={TestBashWorldSarajevoWatchParty}
            alt="Ministry of Testing Sarajevo Watch Party for TestBash World conference"
          />
          <div className="caption">
            <h3>Watch Party</h3>
            <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/collections/testbash-world-2022-d2ca5028-91a6-40ac-a0d4-2c37ea0bc3de"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Watch the Recordings
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={AutomationForJuniorTesters}
            alt="Understanding what is required to start with test automation for junior testers"
          />
          <div className="caption">
            <h3>Test Automation</h3>
            <p className="DarkGreyHeading">LambdaTest - Blog</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.lambdatest.com/blog/automation-for-junior-testers/"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={MakeE2eTestingEasierWithTheRightTools} alt="Make e2e Testing Easier With the Right Tools" />
          <div className="caption">
            <h3>E2E Testing</h3>
            <p className="DarkGreyHeading">LambdaTest - Blog</p>
            <span className="spacer"></span>
            <p><a href="https://www.lambdatest.com/blog/make-e2e-testing-easier/" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Read the article</a></p>
          </div>
        </div>
      </div>

    </div>

    <div className="row   text-align: center">
      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={TwitterSpaceLetsExploreBDD} alt="Make e2e Testing Easier With the Right Tools" />
          <div className="caption">
            <h3>Explore BDD</h3>
            <p className="DarkGreyHeading">MoT - Twitter Spaces</p>
            <span className="spacer"></span>
            <p><a href="https://www.ministryoftesting.com/events/twitter-space-let-s-explore-bdd-with-co-hosts-mirza-sisic-and-simon-tomes" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Open Link</a></p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={Testival2022} alt="Make e2e Testing Easier With the Right Tools" />
          <div className="caption">
            <h3>Keynote Speech</h3>
            <p className="DarkGreyHeading">Testival - Conference</p>
            <span className="spacer"></span>
            <p><a href="https://testival.eu/testival-osijek-2022-sponsors-and-speakers/" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Open Link</a></p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={ExploreAgileSpikesShiftLeftBdd} alt="Let us Explore how Agile Architecture Spikes are used in Shift-Left Behavior Driven Development" />
          <div className="caption">
            <h3>Agile Spikes in BDD</h3>
            <p className="DarkGreyHeading">LambdaTest - Blog</p>
            <span className="spacer"></span>
            <p><a href="https://www.lambdatest.com/blog/agile-architecture-spikes-in-shift-left-bdd" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Read the article</a></p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={MirzaAgileBosniaDays} alt="Make e2e Testing Easier With the Right Tools" />
          <div className="caption">
            <h3>Agile Testing</h3>
            <p className="DarkGreyHeading">Agile Day - Conference</p>
            <span className="spacer"></span>
            <p><a href="https://youtu.be/yC8oANjOIis?list=PLopOoidFSFaiCcfllyxMtJmzo6xyhQ2zn" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Watch Recording</a></p>
          </div>
        </div>
      </div>

    </div>


    <div className="row   text-align: center">
      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={ProductOwnerQA} alt="How Product Owners With Testing Experience Can Promote Quality " />
          <div className="caption">
            <h3>PO Tester</h3>
            <p className="DarkGreyHeading">MoT - The Testing Planet</p>
            <span className="spacer"></span>
            <p><a href="https://www.ministryoftesting.com/articles/2be3bc75?s_id=14301135" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Read the article</a></p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={TestshpereRoulettePodcast} alt="TestSphere Roulette Episode 14 - Lena Pejgan Wiberg and Mirza Sisic. 
            Ministry Of Testing Software Testing / QA Podcast" />
          <div className="caption">
            <h3>TestSphere Roulette</h3>
            <p className="DarkGreyHeading">MoT - Podcast</p>
            <span className="spacer"></span>
            <p><a href="https://soundcloud.com/ministryoftesting/1-testsphere-roulette-episode-14-lena-pejgan-wiberg-and-mirza-sisic" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Podcast Recording</a></p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={TestBashSpringIanMirzaPokekon} alt="Let's test the Pokemon API with REST and GraphQL" />
          <div className="caption">
            <h3>TestBash Spring</h3>
            <p className="DarkGreyHeading">MoT - Conference</p>
            <span className="spacer"></span>
            <p><a href="https://www.ministryoftesting.com/testbash-playlists/testbash-spring-2023" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Watch the Recording</a></p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img className="img-responsive project" src={MobileTestingISQI} alt="key factors to consider when testing mobile applications" />
          <div className="caption">
            <h3>Mobile Testing</h3>
            <p className="DarkGreyHeading">iSQI - Blog</p>
            <span className="spacer"></span>
            <p><a href="https://blog.isqi.org/key-factors-to-consider-when-testing-mobile-applications" className="btn btn-default LightGreyBackground text-center" target="_blank" rel="noopener noreferrer" role="button">Read the article</a></p>
          </div>
        </div>
      </div>
    </div>

    <div className="row   text-align: center">
      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={SarajevoQaCrewMeetup}
            alt="How to pass the ISTQB Foundation Level Certification Exam"
          />
          <div className="caption">
            <h3>How to pass ISTQB CTFL Exam</h3>
            <p className="DarkGreyHeading">QA Crew - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.eventbrite.com/e/qa-meetup-lets-test-together-5-tickets-410034152187?fbclid=IwAR2xMiMgozNACGOIkpPFJwzVrSdHGKoKcFUGpBIrmI4wM6lE0CfqdUk90zo"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Open Link
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BugRaptorsInterview}
            alt="BugRaptors, Tech Talks With Mirza Sisic"
          />
          <div className="caption">
            <h3>BugRaptors Tech Talk with Mirza Sisic</h3>
            <p className="DarkGreyHeading">BugRaptors - Interview</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.bugraptors.com/blog/tech-talks-with-mirza-sisic"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Open Link
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={TestExecutionTime}
            alt="Test Execution Time – why is it important and how can we speed it up?"
          />
          <div className="caption">
            <h3>Test Execution Time why is it important</h3>
            <p className="DarkGreyHeading">LambdaTest - Blog</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.lambdatest.com/blog/test-execution-time/"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={MotSarajevo2023}
            alt="Ministry of Testing Sarajevo 2023 Summer Meetup"
          />
          <div className="caption">
            <h3>MoT Sarajevo 2023 Summer Meetup</h3>
            <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/ministry-of-testing-sarajevo/events/293861821"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View Event
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className="row center">

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={FreelancingForSoftwareTesters}
            alt="Freelancing For Software Testers"
          />
          <div className="caption">
            <h3>Freelancing For Software Testers</h3>
            <p className="DarkGreyHeading">MoT - The Testing Planet</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/articles/7bbd7e69"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={NetWorkBih2023}
            alt="Microsoft Network Bosnia conference in Neum 2023"
          />
          <div className="caption">
            <h3>Team owned quality with Azure DevOps</h3>
            <p className="DarkGreyHeading">NetWork - Conference</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.networkkonferencija.ba/bs-Latn-BA/2023/lectures/2869/team-owned-quality-with-azure-devops-services"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View Event
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={QualityCoachingRoadLessTraveled}
            alt="Ministry of Testing Sarajevo 2023 Summer Meetup"
          />
          <div className="caption">
            <h3>Quality Coaching: A Road Less Traveled</h3>
            <p className="DarkGreyHeading">MoT - The Testing Planet</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/articles/quality-coaching-a-road-less-traveled"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={FeatureSpotlightsJQL}
            alt="Ministry of Testing Sarajevo 2023 Summer Meetup"
          />
          <div className="caption">
            <h3> Feature Spotlights JQL in Jira</h3>
            <p className="DarkGreyHeading">MoT - Conference</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/testbash-playlists/96ace698"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View Event
              </a>
            </p>
          </div>
        </div>
      </div>

    </div>

    <div className="row center">

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={MotSarajevo2024}
            alt="Ministry of Testing Sarajevo 2023 Summer Meetup"
          />
          <div className="caption">
            <h3>MoT Sarajevo 2024 Winter  Meetup</h3>
            <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://youtu.be/G9TjeVlk5eM?t=23"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View recording
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={SystemDuoManualQACourse}
            alt="Ministry of Testing Sarajevo 2023 Summer Meetup"
          />
          <div className="caption">
            <h3>Manual QA for beginners</h3>
            <p className="DarkGreyHeading">SystemDuo - Course</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfgp0_lxzu7tmNq6JJ6JmmPOe-PEnMSFuFu4XnaUaEFYb97PA/viewform"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Course Details
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BeatingTheOddsMot}
            alt="Ministry of Testing Sarajevo 2023 Summer Meetup"
          />
          <div className="caption">
            <h3>Top Tips For New Software Testers</h3>
            <p className="DarkGreyHeading">MoT - The Testing Planet</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/articles/beating-the-odds-in-a-competitive-job-market-top-tips-for-new-software-testers"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={TestCasesMoT}
            alt="In this hot topic we we witnessed some spicy opinions regarding test cases."
          />
          <div className="caption">
            <h3>Test cases...don't write them</h3>
            <p className="DarkGreyHeading">MoT - Testing Trends</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/testing-trends/test-cases-don-t-write-them"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={ReleaseOnFridays}
            alt="Discussion about releasing or not, on Fridays"
          />
          <div className="caption">
            <h3>Brave Enough To Release Software On A Friday?</h3>
            <p className="DarkGreyHeading">MoT - Testing Trends</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/testing-trends/brave-enough-to-release-software-on-a-friday?s_id=18996432"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BrowserStack1stMeetup}
            alt="First Online QA meetup of the BrowserStack Meetup group in Bosnia and Herzegovina."
          />
          <div className="caption">
            <h3>November 2024 meetup</h3>
            <p className="DarkGreyHeading">BrowserStack Bosnia Chapter</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/browserstack-qa-meetup-group-bosnia-and-herzegovina/events/303877620/"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View Event
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={TestCasesMoT}
            alt="Community discussion on cookie testing"
          />
          <div className="caption">
            <h3>When was the last time your team tested cookies?</h3>
            <p className="DarkGreyHeading">MoT - Testing Trends</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/testing-trends/when-was-the-last-time-your-team-tested-cookies?s_id=19000021"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={NetworkBiH2024WhyIAlmostGaveUpOnQA}
            alt="Microsoft Network Bosnia conference in Neum 2024"
          />
          <div className="caption">
            <h3>Why I almost gave up on QA</h3>
            <p className="DarkGreyHeading">Microsoft NetWork Conference</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.networkkonferencija.ba/en/2024/lectures/3031/why-i-almost-gave-up-on-qa"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View Event
              </a>
            </p>
          </div>
        </div>
      </div>

    </div>

    <div className="row center">

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={AllAboutApplicationCookies}
            alt="Discover how cookies affect privacy and UX to be able to test and secure applications effectively."
          />
          <div className="caption">
            <h3>All about application cookies</h3>
            <p className="DarkGreyHeading">MoT - Articles</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/articles/all-about-application-cookies-software-tester-edition"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BrowserStackFeb2025}
            alt="Building a Culture of Testing in Agile Teams with BrowserStack"
          />
          <div className="caption">
            <h3>February 2025 meetup</h3>
            <p className="DarkGreyHeading">BrowserStack Bosnia</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/browserstack-qa-meetup-group-bosnia-and-herzegovina/events/305228457"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View event
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BrowserStackMay2025}
            alt="Building a Culture of Testing in Agile Teams with BrowserStack"
          />
          <div className="caption">
            <h3>BrowserStack May 2025 meetup</h3>
            <p className="DarkGreyHeading">BrowserStack Bosnia</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/browserstack-qa-meetup-group-bosnia-and-herzegovina/events/307064691"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View event
              </a>
            </p>
          </div>
        </div>
      </div>

            <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={LowCodeTestTutomationTools}
            alt="Low-code test automation tools: First impressions and recommendations for beginners"
          />
          <div className="caption">
            <h3>Low-code test automation tools </h3>
            <p className="DarkGreyHeading">MoT - Articles</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/articles/low-code-test-automation-tools-first-impressions-and-recommendations-for-beginners"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

    </div>

     <div className="row center">

            <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BugBash2025}
            alt="Building a Culture of Testing in Agile Teams with BrowserStack"
          />
          <div className="caption">
            <h3>October 2025 BugBash meetup</h3>
            <p className="DarkGreyHeading">BrowserStack Bosnia</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/browserstack-qa-meetup-group-bosnia-and-herzegovina/events/310745376/"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View event
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={MotFairPay}
            alt="Discover how cookies affect privacy and UX to be able to test and secure applications effectively."
          />
          <div className="caption">
            <h3>Getting a fair pay as a software tester</h3>
            <p className="DarkGreyHeading">MoT - Articles</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/articles/all-about-application-cookies-software-tester-edition"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                Read the article
              </a>
            </p>
          </div>
        </div>
      </div>

            <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={Network2025}
            alt="Microsoft Network Bosnia conference in Neum 2024"
          />
          <div className="caption">
            <h3>AI-powered automation tools</h3>
            <p className="DarkGreyHeading">NetWork Conference</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.networkkonferencija.ba/en/2025/lectures/3178/experiences-with-low-code-ai-powered-automation-tools"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View Event
              </a>
            </p>
          </div>
        </div>
      </div>

              <div className="col-sm-6 col-md-3">
          <div className="thumbnail">
            <img
              className="img-responsive project"
              src={MotSarajevo2025Meetup}
              alt="MoT Sarajevo's 2025  Meetup at Academy387 featuring Sladjana Klacar"
            />
            <div className="caption">
              <h3>MoT Sarajevo 2025 Winter Meetup</h3>
              <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
              <span className="spacer"></span>
              <p>
                <a
                  href="https://www.meetup.com/ministry-of-testing-sarajevo/events/311957014"
                  className="btn btn-default LightGreyBackground text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  role="button"
                >
                  View Event
                </a>
              </p>
            </div>
          </div>
        </div>

    </div>

     <div className="row center">

            <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BrowserStackDecember2025}
            alt="Building a Culture of Testing in Agile Teams with BrowserStack"
          />
          <div className="caption">
            <h3>December 2025 Browserstack meetup</h3>
            <p className="DarkGreyHeading">BrowserStack Bosnia</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/browserstack-qa-meetup-group-bosnia-and-herzegovina/events/312152212"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View event
              </a>
            </p>
          </div>
        </div>
      </div>

       <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BrowserStackmarch2026}
            alt="Building a Culture of Testing in Agile Teams with BrowserStack"
          />
          <div className="caption">
            <h3>March 2026 Browserstack meetup</h3>
            <p className="DarkGreyHeading">BrowserStack Bosnia</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/browserstack-qa-meetup-group-bosnia-and-herzegovina/events/312842977/"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View event
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={SoftwareTestingInRegulatedIndustriesCourse}
            alt="Building a Culture of Testing in Agile Teams with BrowserStack"
          />
          <div className="caption">
            <h3>Software Testing in Regulated Industries</h3>
            <p className="DarkGreyHeading">MoT course</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/courses/software-testing-in-regulated-industries-a-beginner-s-guide"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
                View course
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={breakpoint2026}
            alt="Building a Culture of Testing in Agile Teams with BrowserStack"
          />
          <div className="caption">
            <h3>&lt;break&gt;point conference</h3>
            <p className="DarkGreyHeading">BrowserStack conference</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://events.hubilo.com/breakpoint-2026-us-emea-edition/session/272759?messageId=6a05f17282f676ac087ae4f3"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
               Watch recording
              </a>
            </p>
          </div>
        </div>
      </div>

            <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={BrowserStackMay2026}
            alt="Regular Bosnia Browserstack Chapter meetup"
          />
          <div className="caption">
            <h3>June 2026 Browserstack meetup</h3>
            <p className="DarkGreyHeading">BrowserStack Bosnia</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.meetup.com/browserstack-qa-meetup-group-bosnia-and-herzegovina/events/314780886/?eventOrigin=group_past_events"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
              View event
              </a>
            </p>
          </div>
        </div>
      </div>

       <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={MotSarajevoJune2026}
            alt="MoT Sarajevo summer 2026 meetup"
          />
          <div className="caption">
            <h3>MoT Sarajevo 2026 Summer Meetup</h3>
            <p className="DarkGreyHeading">MoT Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://www.ministryoftesting.com/chapters/mot-sarajevo/events/mot-sarajevo-110626"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
              View event
              </a>
            </p>
          </div>
        </div>
      </div>

             <div className="col-sm-6 col-md-3">
        <div className="thumbnail">
          <img
            className="img-responsive project"
            src={GdgSarajevoMay2026}
            alt="Google Developers Group Sarajevo May 2026 monthly meetup"
          />
          <div className="caption">
            <h3>#120th Event AI & Cloud Workshop </h3>
            <p className="DarkGreyHeading">GDG Sarajevo - Meetup</p>
            <span className="spacer"></span>
            <p>
              <a
                href="https://gdg.community.dev/events/details/google-gdg-cloud-sarajevo-presents-120th-event-ai-amp-cloud-workshop-special-guest-mirza-sisic/"
                className="btn btn-default LightGreyBackground text-center"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
              >
              View event
              </a>
            </p>
          </div>
        </div>
      </div>


    </div>

  </div>
);

export default Projects;
